import { CALL_API } from '../../util/RBRestMiddleware'

export const DETAILS_LOADING = 'DETAILS_LOADING'
export const DETAILS_SUCCESS = 'DETAILS_SUCCESS'
export const DETAILS_ERROR = 'DETAILS_ERROR'
export const DETAILS_FAILED = 'DETAILS_FAILED'
export const DETAILS_SEARCH = 'DETAILS_SEARCH'

// get benefit details
export const fetchDetails = (memberId, benefitId, dependentId) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/members/${memberId}/${benefitId}/${dependentId}/benefitDetails`,
        prefix: 'DETAILS',
        onError: (err) => {
          return err
        }
      }
    })
  }
}
export const searchDetails = (searchObj) => {
  return {
    type: DETAILS_SEARCH,
    searchObj
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/benefitDetailsActions.js